import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import { useRecoilState } from "recoil";
import { thumnail } from "../../atoms";

function Thumnail() {
  const [openThumnail, setOpenThumnail] = useRecoilState(thumnail);
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Tooltip title="Thumnail">
      <IconButton
        aria-label="Thumnail"
        color="primary"
        onClick={(e) => {
          setOpenThumnail((prev) => !prev);
          e.currentTarget.blur();
        }}
        sx={{ marginRight: isMobile ? 0 : 2 }}
      >
        <LibraryBooksIcon />
      </IconButton>
    </Tooltip>
  );
}

export default Thumnail;
